import { Extension } from "@tiptap/core";
import { TextSelection } from "@tiptap/pm/state";

export const NewLineBelow = Extension.create({
    name: "newLineBelow",

    addKeyboardShortcuts() {
        return {
            "Ctrl-Enter": ({ editor }) => {
                const { state, view } = editor;
                const { selection } = state;
                const { $from } = selection;

                // Create a new paragraph node
                const paragraph = state.schema.nodes.paragraph.create();

                // Get the position after the current line
                const pos = $from.end();

                // Check if we're inside a list item
                const listItem = $from.node($from.depth - 1);
                if (listItem && listItem.type.name === "listItem") {
                    // We're in a list, so create a new list item instead
                    const listItemType = listItem.type;
                    const paragraph = state.schema.nodes.paragraph.create();
                    const newListItem = listItemType.create(null, paragraph);

                    // Adjust position to insert after the current list item
                    const pos = $from.after($from.depth - 1);

                    // Insert the new list item
                    const tr = state.tr.insert(pos, newListItem);

                    // Set selection to the new list item
                    const newSelection = TextSelection.create(tr.doc, pos + 2); // +2 to get inside the paragraph
                    tr.setSelection(newSelection);

                    // Dispatch the transaction
                    view.dispatch(tr.scrollIntoView());

                    return true;
                } else {
                    // Get the current node's attributes
                    const currentNode = $from.node($from.depth);
                    const attrs = currentNode.attrs || {};
                    
                    // Create a new paragraph node with the same attributes
                    const paragraph = state.schema.nodes.paragraph.create(attrs);
                    
                    // Insert the new paragraph node
                    const tr = state.tr.insert(pos, paragraph);

                    // Set selection to the new line
                    const newSelection = TextSelection.create(tr.doc, pos + 1);
                    tr.setSelection(newSelection);

                    // Dispatch the transaction
                    view.dispatch(tr.scrollIntoView());
                }

                return true;
            },
        };
    },
});
